import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const StarjackContext = createContext(undefined);
export const StarjackProvider = ({ config, children, }) => {
    return (_jsx(StarjackContext.Provider, { value: config, children: children }));
};
export const useStarjackConfig = () => {
    const context = useContext(StarjackContext);
    if (!context) {
        throw new Error('useStarjackConfig must be used within a StarjackProvider');
    }
    return context;
};
